module.exports = __webpack_public_path__ + "static/media/world-everest.82837d52.vtt";